import { Directive, Input, HostListener, OnChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateMask]'
})
export class DateMasksDirective implements OnChanges {

  @Input() appDateMasks: string;

  constructor(private ctrl: NgControl) {}

  private format(v: string): string {
    // const matches = /^\s*(3[01]|[12][0-9]|0?[1-9])\-(1[012]|0?[1-9])\-((?:19|20)\d{2})\s*$/.search(v);
    const matches = v.search(/(3[01]|[12][0-9]|0?[1-9])\-(1[012]|0?[1-9])\-((?:19|20)\d{2})\s*$/);
    return  v;
  }

  /**
   * @description when loading dynamically data to the input, without this
   * the mask will only work on keyup event changes
   */
  @HostListener('change') ngOnChanges() {
    const value = this.ctrl.control.value;
    if (value) {
      this.ctrl.control.setValue(this.format(value));
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp($event: any) {
    if ($event.keyCode !== 13 && $event.keyCode !== 9) {
      const value = this.ctrl.control.value;
      this.ctrl.control.setValue(this.format(value));
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/masks/dateMasks.directive.ts